import type { EventAnalyticsAudienceScope } from "@/queries/analytics/event-reporting-types";

export function hasProjectConnectionAudience(scopes: EventAnalyticsAudienceScope[]): boolean {
  return scopes.some((scope) => scope.type === "projectConnection");
}
